import { css } from 'lit';

export const style = css`
  .fs-pagination__list > li:not(:last-of-type) {
    margin-right: 0 !important;
  }

  button:has(img) {
    background-color: inherit;
    border: none;
    padding: 0 4px 0;
  }
`;
